import Axios from "../../../../../../api/axios/Axios";

export const addCreatorVideo = (username, data) =>
  Axios.post(`/api/creators/${encodeURIComponent(username)}/videos/add`, data);

export const getCreatorVideoUploadUrl = () =>
  Axios.get("/api/creators/videos/s3-url");

export const getCreatorVideoThumbnailUploadUrl = () =>
  Axios.get("/api/creators/videos/thumbnails/s3-url");
